(function () {
  'use strict';

  /* =========================
   * Estado y constantes
   * ========================= */
  const PRICES = {
    'pasaporte-adulto': { normal: 120000, promo: 60000 },
    'pasaporte-nino': { normal: 85000, promo: 42500 },
    'campo-adulto': { normal: 175000, promo: 85000 },
    'campo-nino': { normal: 135000, promo: 67500 },
    'travesia-general': { normal: 70000, promo: 35000 },
  };

  const FECHAS_CERRADAS = [
    '2026-02-03',
    '2026-02-04',
  ];

  const DIAS_CERRADOS = [1];

  let currentUserType = 'colombia';
  let currentLanguage = 'ES';
  let isToday = false;
  let currentSlide = 0;
  const totalSlides = 4;
  const slideInterval = 6000;
  let autoSlideTimer;
  let lastScrollTop = 0;
  const scrollThreshold = 50;
  let ticking = false;

  const topbar = document.querySelector('.topbar');

  /* =========================
   * Utilidades
   * ========================= */
  function formatCOP(amount) {
    return `$${amount.toLocaleString('es-CO')} COP`;
  }

  function safeReplaceState(hashOrPath) {
    history.replaceState(null, '', hashOrPath);
  }

  function scrollToTopSmooth() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  function scrollToSection(sectionId) {
    const section = document.getElementById(sectionId);
    if (!section) return;
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    safeReplaceState(`#${sectionId}`);
  }

  /* =========================
   * Funciones globales
   * ========================= */
  function toggleLanguage() {
    const langBtn = document.getElementById('langToggle');
    if (!langBtn) return;

    const langText = langBtn.querySelector('.header__lang-current');
    if (!langText) return;

    if (currentLanguage === 'ES') {
      currentLanguage = 'EN';
      langText.textContent = 'EN';

      if (typeof Swal !== 'undefined') {
        Swal.fire({
          icon: 'info',
          title: '🌐 Language Changed',
          text: 'English version coming soon!',
          confirmButtonColor: '#ea0b2a',
        });
      }
    } else {
      currentLanguage = 'ES';
      langText.textContent = 'ES';
    }
  }

  function updatePriceDisplay() {
    const stickyCta = document.querySelector('.sticky-cta__text');
    if (stickyCta) {
      stickyCta.innerHTML =
        'Pasaporte desde <strong>$50.000 COP</strong><br><span style="font-size: 0.75rem; color: var(--color-text-light);">10% OFF · Menores de 90cm GRATIS</span>';
    }

    const topbarText = document.querySelector('.topbar__text');
    if (topbarText) {
      topbarText.innerHTML = '🎟️ Niños que midan menos de 90cm ingresan GRATIS';
    }
  }

  function toggleWhatsAppMenu() {
    const whatsappFloat = document.getElementById('whatsappFloat');
    if (!whatsappFloat) return;
    whatsappFloat.classList.toggle('expanded');
  }

  function downloadMapaImage() {
    const img =
      document.getElementById('mapaImg') ||
      document.querySelector('.mapa-visual__image img');

    if (!img) return;

    const src = img.getAttribute('src') || '';
    const filename = 'MAPA_PANACA.png';

    if (src.startsWith('data:image')) {
      const a = document.createElement('a');
      a.href = src;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      return;
    }

    fetch(src)
      .then((r) => r.blob())
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      })
      .catch(() => {
        window.open(src, '_blank');
      });
  }

  function agregarFechaCerrada(fecha) {
    if (!FECHAS_CERRADAS.includes(fecha)) {
      FECHAS_CERRADAS.push(fecha);
      document.querySelectorAll('.flatpickr-input').forEach((input) => {
        if (input._flatpickr) input._flatpickr.redraw();
      });
      console.log('📅 Fecha agregada:', fecha);
    }
  }

  function removerFechaCerrada(fecha) {
    const index = FECHAS_CERRADAS.indexOf(fecha);
    if (index > -1) {
      FECHAS_CERRADAS.splice(index, 1);
      document.querySelectorAll('.flatpickr-input').forEach((input) => {
        if (input._flatpickr) input._flatpickr.redraw();
      });
      console.log('📅 Fecha removida:', fecha);
    }
  }

  function obtenerFechasCerradas() {
    return FECHAS_CERRADAS;
  }

  function openCumpleModal() {
    const modal = document.getElementById('cumpleModal');
    if (!modal) return;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCumpleModal() {
    const modal = document.getElementById('cumpleModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function enviarCotizacion() {
    const nombre = document.getElementById('cumpleNombre')?.value.trim() || '';
    const tel = document.getElementById('cumpleTelefono')?.value.trim() || '';
    const email = document.getElementById('cumpleEmail')?.value.trim() || '';
    const fecha = document.getElementById('cumpleFecha')?.value || '';
    const invitados = document.getElementById('cumpleInvitados')?.value || '';
    const edad = document.getElementById('cumpleEdad')?.value || '';
    const notas = document.getElementById('cumpleNotas')?.value.trim() || '';

    if (!nombre || !tel || !fecha || !invitados) {
      alert('Por favor completa los campos obligatorios (*)');
      return;
    }

    let msg = '🎂 *COTIZACIÓN CUMPLEAÑOS EN PANACA*\n\n';
    msg += '👤 *Nombre:* ' + nombre + '\n';
    msg += '📱 *Teléfono:* ' + tel + '\n';
    if (email) msg += '📧 *Email:* ' + email + '\n';
    msg += '📅 *Fecha deseada:* ' + fecha + '\n';
    msg += '👥 *Invitados:* ' + invitados + ' personas\n';
    if (edad) msg += '🎈 *Edad cumpleañero(a):* ' + edad + ' años\n';
    if (notas) msg += '\n📝 *Detalles adicionales:*\n' + notas + '\n';
    msg += '\n_Enviado desde panaca.co_';

    const url = 'https://wa.me/573106818818?text=' + encodeURIComponent(msg);
    window.open(url, '_blank');
    closeCumpleModal();
  }

  /* =========================
   * Configuración Flatpickr
   * ========================= */
  const flatpickrConfig = {
    locale: 'es',
    dateFormat: 'Y-m-d',
    altInput: true,
    altFormat: 'd/m/Y',
    minDate: 'today',
    disableMobile: false,
    disable: [
      function (date) {
        const dateStr = date.toISOString().split('T')[0];

        if (FECHAS_CERRADAS.includes(dateStr)) return true;
        if (DIAS_CERRADOS.includes(date.getDay())) return true;

        return false;
      },
    ],
    onReady: function (selectedDates, dateStr, instance) {
      const calendarContainer = instance.calendarContainer;

      const buttonContainer = document.createElement('div');
      buttonContainer.style.cssText =
        'display: flex; justify-content: space-between; padding: 8px 12px; border-top: 1px solid #eee;';

      const clearBtn = document.createElement('span');
      clearBtn.className = 'flatpickr-clear';
      clearBtn.textContent = 'Clear';
      clearBtn.onclick = () => instance.clear();

      const todayBtn = document.createElement('span');
      todayBtn.className = 'flatpickr-today-button';
      todayBtn.textContent = 'Today';
      todayBtn.onclick = () => {
        const today = new Date();
        const todayStr = today.toISOString().split('T')[0];

        if (
          !FECHAS_CERRADAS.includes(todayStr) &&
          !DIAS_CERRADOS.includes(today.getDay())
        ) {
          instance.setDate(today, true);
        } else if (typeof Swal !== 'undefined') {
          Swal.fire({
            icon: 'info',
            title: 'Fecha no disponible',
            text: 'El parque está cerrado hoy. Por favor selecciona otra fecha.',
          });
        }
      };

      buttonContainer.appendChild(clearBtn);
      buttonContainer.appendChild(todayBtn);
      calendarContainer.appendChild(buttonContainer);
    },
  };

  /* =========================
   * Inicialización
   * ========================= */
  function initAIBox() {
    const box = document.getElementById('aiBox');
    if (box) box.removeAttribute('open');
  }

  function initScrollTicking() {
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  function initWhatsApp() {
    document.addEventListener('click', function (e) {
      const whatsappFloat = document.getElementById('whatsappFloat');
      if (!whatsappFloat) return;

      if (
        !whatsappFloat.contains(e.target) &&
        whatsappFloat.classList.contains('expanded')
      ) {
        whatsappFloat.classList.remove('expanded');
      }
    });

    const whatsappBtn = document.querySelector('.whatsapp-float__btn');
    if (whatsappBtn) {
      whatsappBtn.addEventListener('click', function () {
        const badge = this.querySelector('.whatsapp-float__badge');
        if (badge) {
          setTimeout(() => {
            badge.style.display = 'none';
          }, 500);
        }
      });
    }
  }

  function initTestimoniosCarousel() {
    const root = document.querySelector('[data-carousel="testimonios"]');
    if (!root) return;

    const viewport = root.querySelector('[data-carousel-viewport="testimonios"]');
    const track = root.querySelector('.carousel-track');
    const prevBtn = root.querySelector('.carousel-btn--prev');
    const nextBtn = root.querySelector('.carousel-btn--next');
    const dotsWrap = document.querySelector('[data-carousel-dots="testimonios"]');

    if (!viewport || !track || !prevBtn || !nextBtn || !dotsWrap) return;

    const slides = Array.from(track.querySelectorAll('.testimonio'));
    if (!slides.length) return;

    const perView = () =>
      window.innerWidth >= 1024 ? 3 : window.innerWidth >= 640 ? 2 : 1;

    let pages = 0;
    let currentPage = 0;
    let raf = null;

    function updateControls() {
      const pv = perView();
      pages = Math.max(1, Math.ceil(slides.length / pv));
      currentPage = Math.min(currentPage, pages - 1);

      prevBtn.disabled = currentPage <= 0;
      nextBtn.disabled = currentPage >= pages - 1;

      const show = pages > 1;
      prevBtn.style.display = show ? '' : 'none';
      nextBtn.style.display = show ? '' : 'none';
      dotsWrap.style.display = show ? 'flex' : 'none';

      Array.from(dotsWrap.children).forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentPage);
      });
    }

    function goToPage(page, smooth = true) {
      const pv = perView();
      const targetIndex = Math.min(slides.length - 1, page * pv);
      const target = slides[targetIndex];
      if (!target) return;

      viewport.scrollTo({
        left: target.offsetLeft,
        behavior: smooth ? 'smooth' : 'auto',
      });
    }

    function buildDots() {
      pages = Math.max(1, Math.ceil(slides.length / perView()));
      dotsWrap.innerHTML = '';

      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'carousel-dot' + (i === currentPage ? ' is-active' : '');
        b.setAttribute('aria-label', 'Ir a la página ' + (i + 1) + ' de testimonios');
        b.addEventListener('click', () => goToPage(i, true));
        dotsWrap.appendChild(b);
      }

      updateControls();
    }

    function detectPage() {
      const leftEdge = viewport.getBoundingClientRect().left;
      let bestIdx = 0;
      let bestDelta = Infinity;

      slides.forEach((slide, idx) => {
        const r = slide.getBoundingClientRect();
        const delta = r.left - leftEdge;
        if (delta >= -6 && delta < bestDelta) {
          bestDelta = delta;
          bestIdx = idx;
        }
      });

      currentPage = Math.floor(bestIdx / perView());
      updateControls();
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        detectPage();
      });
    }

    prevBtn.addEventListener('click', () =>
      goToPage(Math.max(0, currentPage - 1), true)
    );
    nextBtn.addEventListener('click', () =>
      goToPage(Math.min(pages - 1, currentPage + 1), true)
    );
    viewport.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', () => {
      buildDots();
      goToPage(currentPage, false);
    });

    buildDots();
    setTimeout(detectPage, 100);
  }

  function initFlatpickrCalendars() {
    if (typeof flatpickr === 'undefined') return;

    const fechaVisitaInput = document.getElementById('fechaVisita');
    if (!fechaVisitaInput) {
      console.log('📅 Calendarios inicializados con fechas bloqueadas:', FECHAS_CERRADAS);
      return;
    }

    flatpickr(fechaVisitaInput, {
      ...flatpickrConfig,
      defaultDate: 'today',
      onChange: function (selectedDates, dateStr) {
        const today = new Date().toISOString().split('T')[0];
        const isSelectedToday = dateStr === today;

        const hint = document.getElementById('discountHint');
        if (hint) {
          if (isSelectedToday) {
            hint.textContent = '⚠️ Para compras del mismo día, adquiere en taquilla.';
            hint.style.color = 'var(--color-red)';
          } else if (dateStr) {
            hint.textContent = '';
            hint.style.color = '#629B3D';
          }
        }

        try {
          if (typeof checkTravesiaAvailability === 'function') {
            checkTravesiaAvailability();
          }
        } catch (e) {}
      },
    });

    console.log('📅 Calendarios inicializados con fechas bloqueadas:', FECHAS_CERRADAS);
  }

  function initAnchorNavigation() {
    const inicioLinks = document.querySelectorAll(
      '.nav-menu__link[href="#inicio"], .header__nav-link[href="#inicio"], .header__logo'
    );

    inicioLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        scrollToTopSmooth();
        safeReplaceState(window.location.pathname);
      });
    });

    const ubicacionLink = document.querySelector('.nav-menu__link[href="#ubicacion"]');
    if (ubicacionLink && document.getElementById('ubicacion')) {
      ubicacionLink.addEventListener('click', (e) => {
        e.preventDefault();
        scrollToSection('ubicacion');
      });
    }

    const horariosLinks = document.querySelectorAll(
      '.nav-menu__link[href="#horarios"], .header__nav-link[href="#horarios"]'
    );
    if (horariosLinks.length && document.getElementById('horarios')) {
      horariosLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          scrollToSection('horarios');
        });
      });
    }

    const restauranteLinks = document.querySelectorAll(
      '.nav-menu__link[href="#restaurante"], .header__nav-link[href="#restaurante"]'
    );
    if (restauranteLinks.length && document.getElementById('restaurante')) {
      restauranteLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          scrollToSection('restaurante');
        });
      });
    }
  }

  function initBackToTop() {
    const btn = document.getElementById('backTopLeft');
    if (!btn) return;

    const toggle = () => {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      btn.style.display = y > 400 ? 'flex' : 'none';
    };

    btn.addEventListener('click', () => {
      scrollToTopSmooth();
      safeReplaceState('#inicio');
    });

    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('load', toggle);
    toggle();
  }

  function initHeroVideoMobile() {
    const v = document.getElementById('heroVideoMobile');
    if (!v) return;

    const src = v.querySelector('source[data-src]');
    if (!src) return;

    if (window.innerWidth > 768) return;

    const load = function () {
      src.setAttribute('src', src.getAttribute('data-src'));
      src.removeAttribute('data-src');
      v.load();
      v.play().catch(function () {});
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(load, { timeout: 2000 });
    } else {
      setTimeout(load, 1500);
    }
  }

  function initRestaurantsToggle() {
    const grid = document.querySelector('.rest-grid--collapsible');
    const btn = document.getElementById('restToggleBtn');
    const label = document.getElementById('restCountLabel');

    if (!grid || !btn) return;

    const cards = grid.querySelectorAll(':scope > .rest-card');
    const total = cards.length;
    const limit = 4;

    function setLabel() {
      if (!label) return;

      if (grid.classList.contains('rest-grid--collapsed')) {
        label.textContent = 'Mostrando ' + Math.min(limit, total) + ' de ' + total;
      } else {
        label.textContent = 'Mostrando ' + total + ' de ' + total;
      }
    }

    btn.textContent = 'Ver todos los restaurantes';
    btn.setAttribute('aria-expanded', 'false');
    setLabel();

    btn.addEventListener('click', function () {
      const collapsed = grid.classList.contains('rest-grid--collapsed');

      if (collapsed) {
        grid.classList.remove('rest-grid--collapsed');
        btn.textContent = 'Ver menos';
        btn.setAttribute('aria-expanded', 'true');
      } else {
        grid.classList.add('rest-grid--collapsed');
        btn.textContent = 'Ver todos los restaurantes';
        btn.setAttribute('aria-expanded', 'false');
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      setLabel();
    });

    if (total <= limit) {
      btn.style.display = 'none';
      if (label) label.style.display = 'none';
      grid.classList.remove('rest-grid--collapsed');
    }
  }

  function initModalTriggers() {
    document.querySelectorAll('[data-open-modal="true"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (typeof openModal === 'function') {
          e.preventDefault();
          openModal();
        }
      });
    });

    if (window.location.href.includes('?pay') && typeof openModal === 'function') {
      openModal();
    }
  }

  function init() {
    initAIBox();
    initScrollTicking();
    initWhatsApp();
    initTestimoniosCarousel();
    initFlatpickrCalendars();
    initAnchorNavigation();
    initBackToTop();
    initHeroVideoMobile();
    initRestaurantsToggle();
    initModalTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* =========================
   * Exponer globals usados por HTML inline
   * ========================= */
  window.PRICES = PRICES;
  window.toggleLanguage = toggleLanguage;
  window.updatePriceDisplay = updatePriceDisplay;
  window.formatCOP = formatCOP;
  window.toggleWhatsAppMenu = toggleWhatsAppMenu;
  window.downloadMapaImage = downloadMapaImage;
  window.agregarFechaCerrada = agregarFechaCerrada;
  window.removerFechaCerrada = removerFechaCerrada;
  window.obtenerFechasCerradas = obtenerFechasCerradas;
  window.openCumpleModal = openCumpleModal;
  window.closeCumpleModal = closeCumpleModal;
  window.enviarCotizacion = enviarCotizacion;
})();

function pbdayOpenCumpleCompraModal() {
  document.getElementById('pbdayCcAdult').value = 1;
  document.getElementById('pbdayCcNino').value = 0;
  document.getElementById('pbdayCumpleCompraModal').classList.add('is-open');
  document.body.style.overflow = 'hidden';
 // ccUpdatePlan();
}